<template>
  <b-container>
    <b-embed
      v-if="accessBankSlip"
      :src="dashboardUrl"
      type="iframe"
      aspect="16by9"
      allowfullscreen
    />
    <noPermission
      v-else
      style="margin-top: 0 !important;"
    />
  </b-container>
</template>

<script>
import {
  BContainer,
  BEmbed,
} from 'bootstrap-vue'


import noPermission from '@/views/error/NoPermission.vue'

import { getMerchantData } from '@/utils/get-merchant-data'

const jwt = require('jsonwebtoken')

export default {
  components: {
    BContainer,
    BEmbed,
    noPermission,
  },
  data() {
    return {
      dashboardUrl: null,
      accessBankSlip: false,
    }
  },
  async mounted() {
    const permissions = getMerchantData().permissions.map(permission => +permission)
    this.accessBankSlip = permissions.some(permissionCode => permissionCode === 4)
    if (!this.accessBankSlip) {
      return
    }
    const METABASE_SITE_URL = metaUrl()
    const METABASE_SECRET_KEY = accessKey()

    const payload = {
      resource: {
        dashboard: 579,
      },
      params: {
        ec: sessionStorage.getItem('veripagID').toString(),
      },
      exp: Math.round(Date.now() / 1000) + 10 * 60, // 10 minute expiration
    }

    const token = await jwt.sign(payload, METABASE_SECRET_KEY)
    this.dashboardUrl = `${METABASE_SITE_URL}embed/dashboard/${token}#bordered=true&titled=true`
  },
  methods: {

  },
}
</script>
